"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _AssignmentCard = _interopRequireDefault(require("../../components/Card/AssignmentCard.js"));
var _HiddenBlock = _interopRequireDefault(require("../../components/HiddenBlock"));
var _admin = require("../../reducers/admin.js");
var _admin2 = require("../../selectors/admin.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ProjectDetail = /*#__PURE__*/function (_React$Component) {
  function ProjectDetail() {
    _classCallCheck(this, ProjectDetail);
    return _callSuper(this, ProjectDetail, arguments);
  }
  _inherits(ProjectDetail, _React$Component);
  return _createClass(ProjectDetail, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        project = _this$props.project,
        assignmentTerm = _this$props.assignmentTerm,
        expandedDesignAssignmentIds = _this$props.expandedDesignAssignmentIds,
        showArchivedAssignments = _this$props.showArchivedAssignments;
      var assignmentList = project.flows.assignmentList.filter(function (item) {
        return !item.archived;
      });
      var archivedAssignmentList = project.flows.assignmentList.filter(function (item) {
        return item.archived;
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "cccisd-design-area"
      }, /*#__PURE__*/_react["default"].createElement("div", null, assignmentList.length === 0 ? /*#__PURE__*/_react["default"].createElement("h3", {
        className: _style["default"].empty
      }, "Create a new ", assignmentTerm, " to begin...") : assignmentList.map(function (assignmentItem) {
        return /*#__PURE__*/_react["default"].createElement(_AssignmentCard["default"], {
          key: assignmentItem.assignmentId,
          isExpanded: expandedDesignAssignmentIds.includes(assignmentItem.assignmentId),
          project: project,
          assignmentData: assignmentItem,
          assignmentTerm: assignmentTerm,
          numActiveSurveys: assignmentList.length
        });
      }), archivedAssignmentList.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_HiddenBlock["default"], {
        label: "Archived Quests (".concat(archivedAssignmentList.length, ")"),
        show: showArchivedAssignments,
        toggle: this.props.toggleArchivedAssignments
      }, archivedAssignmentList.map(function (assignmentItem) {
        return /*#__PURE__*/_react["default"].createElement(_AssignmentCard["default"], {
          key: assignmentItem.assignmentId,
          isExpanded: expandedDesignAssignmentIds.includes(assignmentItem.assignmentId),
          project: project,
          assignmentData: assignmentItem,
          assignmentTerm: assignmentTerm,
          numActiveSurveys: assignmentList.length
        });
      })))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(ProjectDetail, "propTypes", {
  project: _propTypes["default"].object,
  assignmentTerm: _propTypes["default"].string,
  expandedDesignAssignmentIds: _propTypes["default"].array,
  showArchivedAssignments: _propTypes["default"].bool,
  toggleArchivedAssignments: _propTypes["default"].func
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    project: (0, _admin2.getFilteredCurrentProjectForDesign)(state.assignment.admin),
    expandedDesignAssignmentIds: state.assignment.admin.expandedDesignAssignmentIds,
    showArchivedAssignments: state.assignment.admin.showArchivedAssignments
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  toggleArchivedAssignments: _admin.toggleArchivedAssignments
})(ProjectDetail);